import {register} from '@shopify/theme-sections';

export default register('image-node', {
  onLoad() {
    const tabContentEls = this.container.querySelectorAll('.js-tabcontent.loading');
    tabContentEls.forEach((tabcontent) => tabcontent.classList.remove('loading'));

    const tablistLinks = this.container.querySelectorAll('.js-tablist__link');
    const tablistPanels = this.container.querySelectorAll('.js-tabcontent');

    const handleTabHover = (event, tabPanel) => {
      event.preventDefault();
      const target = event.target;

      if (target.getAttribute('aria-selected') === 'true') {
        return;
      }

      // reset all here
      tablistLinks.forEach((link) => {
        link.setAttribute('aria-selected', false);
      });
      tablistPanels.forEach((panel) => {
        panel.setAttribute('aria-hidden', true);
      });

      // set new attributes to match click event
      target.setAttribute('aria-selected', true);
      tabPanel.setAttribute('aria-hidden', false);
    };

    // Event listener when tab links are hovered
    if (tablistLinks.length > 0) {
      tablistLinks.forEach((link) => {
        link.addEventListener('mouseover', (event) => {
          const tabID = link.getAttribute('aria-controls');
          const tabPanel = document.getElementById(tabID);
          handleTabHover(event, tabPanel);
        });
      });
    }
  },
});
